import React, { useEffect, useState, useRef } from 'react'
import { InputBox, FormButton, Switch, AutoCompleteBox, AutoCompleteBoxWithLabel, CheckBoxInput } from "../commoncomponents/InputBox";
import { useAuth } from '../../context/auth';
import { Table } from '../commoncomponents/Table';
//loder
import BlurLoader from "../Loder/BlurLoader";
//react toast 
import { toast } from 'react-toastify';
//common Data
import { API_SERVER, handleDownloadExcel, initializeFilterData } from '../../Utils';
//services
import { post } from '../../apiservices/service';
import { getCommonData, getMasterData } from '../../apiservices/CommonServices';
import { Token, number } from '../Common/Common';

function ViewCompanyPolicy() {
	const inputrefs = useRef([]);
	const { user, sessionExpired } = useAuth();
	const TokenData = Token()
	const [recipe, setRecipe] = useState({
		employee: '',
	})

	const [result, setResult] = useState({});
	const [loading, setLoading] = useState(false);
	const [currentPageNo, setCurrentPageNo] = useState(1);
	const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
	const [filterData, setFilterData] = useState(initializeFilterData);
	const [isUpdate, setIsUpdate] = useState(false);
	const [errors, setErrors] = useState({});
	const [ShowEdit, setShowEdit] = useState(false);


	const getFormData = (emp, CurrentPage) => {
		let PageIndex = 1
		if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
			PageIndex = CurrentPage;
			setCurrentPageNo(CurrentPage);
		}
		else {
			setCurrentPageNo(1);
		}

		setLoading(true)

		let temp = {
			PageIndex: PageIndex.toString(),
			SearchText: "",
			StartValue: "1",
			SearchFieldValue: "",
			Type: "s",
		}
		post(`${API_SERVER}api/Report/ShowCompanyPolicyMaster`, { ...TokenData, ...temp, ...sortConfig, ...filterData}, (res) => {
			if (res && res.Status) {
				if (res.Status === "ERROR") {
					setLoading(false)
					setResult({ ...res })
				} else if (res.Status === "EXPIRED") {
					toast.error(res.Message)
					sessionExpired()
				} else if (res.Status === "UNAUTHORIZED") {
					toast.error(res.Message);
					handleClear();
					setLoading(false);
				} else {
					setLoading(false)
					setResult({ ...res })
				}
			}
		});
	}

	const handleChange1 = (event, value) => {
		getFormData(recipe.employee, value);
	};

	useEffect(() => {
		document.title = 'Viva HRMS : View Company Policy';
		getFormData()
	}, [sortConfig, isUpdate])


	//Change Handler
	const HandleChange = (prop, value) => {
		setRecipe(recipe => ({ ...recipe, [prop]: value }))
	}

	//Reset Handler
	const handleClear = () => {
		setRecipe(recipe => ({
			...recipe,
			employee: "",
		}))
		setErrors({})
		setFilterData(filterData => ({ ...filterData, SearchText: '' }))
		setIsUpdate(!isUpdate)
		getFormData()
		setShowEdit(false)
	}

	const handleSorting = (SortColumn) => {
		let SortOrder = 'ASC';

		if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
			SortOrder = 'DESC';
		}
		setSortConfig({ SortColumn, SortOrder });
	};


	//End Export functionality
	const HandleShowDoc = (ID, key) => {
		setLoading(true)
		post(`${API_SERVER}api/Report/ShowPolicyDocument`, { ...TokenData, PolicyID: ID }, (res) => {
			if (res && res.status) {
				if (res.status === "ERROR") {
					setLoading(false)
					toast.error(res.message)
				} else if (res.status === "EXPIRED") {
					toast.error(res.message)
					sessionExpired()
				} else if (res.status === "UNAUTHORIZED") {
					toast.error(res.message);
					setLoading(false);
				} else {
					setLoading(false)
					let base64 = res && res.document
					const byteCharacters = atob(base64);
					const byteNumbers = new Array(byteCharacters.length);
					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					const byteArray = new Uint8Array(byteNumbers);
					const blob = new Blob([byteArray], { type: res.documentExtention === '' ? toast.error('No Document Uploaded') : res.documentExtention === 'pdf' ? 'application/pdf' : 'image/jpeg' });
					const blobURL = URL.createObjectURL(blob);
					setLoading(false)
					const pdfWindow = window.open();
					if (pdfWindow) {
						pdfWindow.location.href = blobURL;
					} else {
						alert("Popup blocked! Please allow popups for this website.");
					}

				}
			}
		});
	}

	return (
		<>
			<div className='main-card card border-0'>
				<div className='card-header mb-1'>
					<h6 className="m-0">View Company Policy</h6>
				</div>
			</div>

			<Table
				Token={TokenData}
				Action={false}
				PageName='ViewCompanyPolicy'
				HandleShowDoc={HandleShowDoc}
				handleFilter={() => {
					getFormData();
					setFilterData({
						...filterData,
					});
				}}
				tableData={result}
				filterData={filterData}
				setFilterData={setFilterData}
				currentPageNo={currentPageNo}
				handleChange1={handleChange1}
				handleSorting={handleSorting}
				sortConfig={sortConfig}
			/>

			{loading && < BlurLoader />}
		</>
	)
}

export default ViewCompanyPolicy
